// extracted by mini-css-extract-plugin
export default {"bubbleContainer":"textedbubble_bubbleContainer__0LC-S"};